import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { RoundedBlock } from '@r1-frontend/ui-react/experimental/blocks';
import { ResizableTextarea } from '@r1-frontend/ui-react/experimental/forms';

export const Block = styled.div`
    display: block;
    width: 100%;
    
    ${ResizableTextarea} {
        width: 100%;
    }
`;

export const MainWrapper = styled(RoundedBlock)`
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 36px;

    padding: 24px;
    
    overflow: hidden;
    width: 100%;
`;

export const InnerWrapper = styled.div`
    max-width: 295px;
    
    @media (min-width: ${wideBreakpoints.mobile}) {
        max-width: 600px;
        width: 100%;
    }
    
    display: flex;
    flex-direction: row;
        
    gap: 28px;
`;

const DefaultWrapper = styled.div`
    display: flex;
    gap: 2px;
`;

export const DeliveryOptionsWrapper = styled(DefaultWrapper)`
    flex-direction: column;

    & > * {
        max-width: 314px;
    }
`;

export const DaysSection = styled.div`
    display: block;
    
    ${Button} {
        margin-top: 20px;
    }
`;

export const DaysWrapper = styled(DefaultWrapper)`
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
`;

export const HoursWrapper = styled(DaysWrapper)`
    flex-wrap: wrap;
    padding-bottom: 0;
`;
